import React from "react";
import { Link } from "react-router-dom";
import zainLogo from "../../images/zain-logo2.svg";
import {AiOutlineFacebook , AiOutlineWhatsApp , AiOutlineTwitter} from "react-icons/ai";
import { CiFacebook } from "react-icons/ci";
import { FiPhoneCall } from "react-icons/fi";
import { CiMail } from "react-icons/ci";
import { BiCategory } from "react-icons/bi";
import { SiInformatica } from "react-icons/si";
import { SiContactlesspayment } from "react-icons/si";


const Footer = () => {
  // window.addEventListener('load', function() {

  //   function updateOnlineStatus(event) {
  //     console.log("data-online", navigator.onLine);
      
  //   }
  //   updateOnlineStatus();
  //   window.addEventListener('online',  updateOnlineStatus);
  //   window.addEventListener('offline', updateOnlineStatus);
  // });
  return (
    <div className=" tw-mt-20">
      <div className="navbar-bg tw-p-6 tw-overflow-hidden tw-relative tw-h-[500px] md:tw-h-[720px]">

        <div className="footer-wave" dir="ltr">
          <svg
            data-name="Layer 1"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 1200 120"
            preserveAspectRatio="none"
          >
            <path
              d="M985.66,92.83C906.67,72,823.78,31,743.84,14.19c-82.26-17.34-168.06-16.33-250.45.39-57.84,11.73-114,31.07-172,41.86A600.21,600.21,0,0,1,0,27.35V120H1200V95.8C1132.19,118.92,1055.71,111.31,985.66,92.83Z"
              className="shape-fill"
            ></path>
          </svg>
        </div>

        <div className="info-footer tw-w-full tw-flex tw-justify-center sm:tw-justify-start tw-items-center tw-mt-7 md:tw-mt-5 xs:tw-mt-2">
          <div className="tw-w-[80%] tw-p-2 tw-flex tw-justify-between md:tw-flex-col-reverse md:tw-gap-10 tw-items-center md:tw-items-start  xs:tw-mr-4 tw-mx-auto">
            {/* <div className="tw-flex tw-justify-center tw-flex-col tw-items-center tw-gap-4 tw-text-3xl lg:tw-text-2xl sm:tw-text-2xl xs:tw-text-xl tw-text-white tw-border-r tw-h-[200px] tw-w-24 sm:tw-h-auto tw-w-300px tw-border-gray-400 tw-py-2 tw-pr-6">
              <div className="tw-p-2 sm:tw-p-1 tw-group tw-shadow-sm tw-shadow-gray-400 hover:tw-shadow-gray-300 tw-cursor-pointer tw-rounded-lg">
                <span className="tw-cursor-pointer group-hover:tw-text-gray-300 tw-transition-all tw-duration-500 tw-ease-linear"><CiFacebook /></span>
              </div>
              <div className="tw-p-2 sm:tw-p-1 tw-group tw-shadow-sm tw-shadow-gray-400 hover:tw-shadow-gray-300 tw-cursor-pointer tw-rounded-lg">
                <span className="tw-cursor-pointer group-hover:tw-text-gray-300 tw-transition-all tw-duration-500 tw-ease-linear"><AiOutlineWhatsApp /></span>
              </div>
              <div className="tw-p-2 sm:tw-p-1 tw-group tw-shadow-sm tw-shadow-gray-400 hover:tw-shadow-gray-300 tw-cursor-pointer tw-rounded-lg">
                <span className="tw-cursor-pointer group-hover:tw-text-gray-300 tw-transition-all tw-duration-500 tw-ease-linear"><AiOutlineTwitter /></span>
              </div>
            </div> */}
             <div>
                <h3 className="tw-text-white">تواصل معنا</h3>
                <div className="tw-grid tw-grid-cols-1 tw-gap-6 tw-items-center tw-mt-2 ">
                  <div className="tw-flex tw-items-center tw-gap-6 tw-pb-3 tw-border-b tw-border-transparent-white tw-cursor-pointer hover:tw-bg-transparent-black2 tw-p-2 tw-px-3 tw-rounded-sm tw-duration-500">
                    <span className="tw-p-3 sm:tw-p-2 tw-text-xl sm:tw-text-sm tw-text-center tw-flex tw-justify-center tw-items-center tw-bg-white tw-text-second-zain tw-bg-one-gold tw-rounded-full">
                      <FiPhoneCall />
                    </span>
                    <span className=" tw-text-white tw-flex tw-flex-col sm:tw-text-sm">
                      <span className="tw-font-semibold tw-text-one-gold">
                        الهاتف
                      </span>
                      <span className="tw-mt-1">
                      249912300000+
                      </span>
                    </span>
                  </div>
                  <div className="tw-flex tw-items-center tw-gap-6 tw-pb-3 tw-border-b tw-border-transparent-white tw-cursor-pointer hover:tw-bg-transparent-black2 tw-p-2 tw-px-3 tw-rounded-sm tw-duration-500">
                    <span className="tw-p-3 sm:tw-p-2 tw-text-xl sm:tw-text-sm tw-text-center tw-flex tw-justify-center tw-items-center tw-bg-white tw-text-second-zain tw-rounded-full">
                      <CiMail />
                    </span>
                    <span className="tw-text-white tw-flex tw-flex-col sm:tw-text-sm">
                      <span className=" tw-font-semibold tw-text-one-gold">
                        إيميل
                      </span>
                      <span className="tw-mt-1">
                      alsaganaplatform@gmail.com
                      </span>
                    </span>
                  </div>
                </div>
              </div>
            <div className="tw-flex tw-justify-center tw-flex-col tw-items-center tw-gap-5 tw-text-xl lg:tw-text-lg sm:tw-text-sm xs:tw-text-xs tw-text-white tw-py-2">
              <Link to="/about" className="tw-whitespace-nowrap tw-p-2 tw-border-b tw-border-transparent hover:tw-border-b hover:tw-border-b-gray-400 hover:tw-bg-white hover:tw-text-second-zain tw-rounded-md tw-px-6 tw-transition-all tw-duration-500 tw-ease-in-out tw-flex tw-items-center tw-gap-2">
                <span><SiInformatica /></span>
                <span>عن المنصة</span>
              </Link>
              <Link to="/" className="tw-whitespace-nowrap tw-p-2 tw-border-b tw-border-transparent hover:tw-border-b hover:tw-border-b-gray-400 hover:tw-bg-white hover:tw-text-second-zain tw-rounded-md tw-px-6 tw-transition-all tw-duration-500 tw-ease-in-out tw-flex tw-items-center tw-gap-2">
                <span><BiCategory /></span>
                <span>التصنيفات</span>
              </Link>
              <Link className="tw-whitespace-nowrap tw-py-2 tw-border-b tw-border-transparent hover:tw-border-b hover:tw-border-b-gray-400 hover:tw-bg-white hover:tw-text-second-zain tw-rounded-md tw-px-6 tw-transition-all tw-duration-500 tw-ease-in-out tw-flex tw-items-center tw-gap-2">
                <span><SiContactlesspayment /></span>
                <span>إشترك الان</span>
              </Link>
            </div>
            <div>
            <img src={zainLogo}  className="tw-w-[130px] md:tw-w-[100px] xs:tw-w-[90px] tw-cursor-pointer"/>
            </div>
          </div>
        </div>

        <div className="tw-absolute tw-bottom-3 sm:tw-bottom-2 tw-left-0 tw-flex tw-justify-center tw-items-center tw-p-3 tw-w-full tw-border-t tw-border-gray-400">
          <a href="http://right-businesses.com/" target="_blank" rel="noopener noreferrer">
              <h1 className="tw-text-gray-400 tw-mt-2 sm:tw-mt-1 sm:tw-text-[13px] xs:tw-text-[10px]">Copyright &copy; <span> Right Businesses</span> all rights reserved</h1>
          </a>
        </div>

      </div>
    </div>
  );
};

export default Footer;
